var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPainPointMidBackGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78.658,
    height: 93.774,
    viewBox: "0 0 78.658 93.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3759",
    "data-name": "Rectangle 3759",
    width: 27.439,
    height: 40.26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3758",
    "data-name": "Rectangle 3758",
    width: 18.86,
    height: 27.672,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3760",
    "data-name": "Rectangle 3760",
    width: 31.437,
    height: 45.828,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3761",
    "data-name": "Rectangle 3761",
    width: 25.557,
    height: 36.576,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3762",
    "data-name": "Rectangle 3762",
    width: 13.252,
    height: 19.444,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3763",
    "data-name": "Rectangle 3763",
    width: 3.943,
    height: 5.785,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3764",
    "data-name": "Rectangle 3764",
    width: 10.198,
    height: 6.392,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3765",
    "data-name": "Rectangle 3765",
    width: 7.946,
    height: 10.894,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3766",
    "data-name": "Rectangle 3766",
    width: 4.192,
    height: 4.62,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3767",
    "data-name": "Rectangle 3767",
    width: 11.756,
    height: 4.007,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3768",
    "data-name": "Rectangle 3768",
    width: 8.509,
    height: 9.981,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3769",
    "data-name": "Rectangle 3769",
    width: 9.994,
    height: 7.292,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4930",
    "data-name": "Group 4930",
    transform: "translate(-1678.157 -750.023)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7031",
    "data-name": "Path 7031",
    d: "M97.675,134.591l.546-8.712,2.505,3.746,8.928-6.8-3.153-5.116L99.37,106.2,86.807,98.74s-7.837,1.873-12.536,0c-4.714-1.865-4.059-4.308-4.059-4.308H59.269l-2.452-3.658-7.6,8.45,6.149,8.339,6.749,7.442,1.968,6.158,3.583,6.562,1.461,6.422L64.3,142.04s-.021,2.819,11.3,7.89c16.345,6.584,24.5-.2,24.5-.2l-1.923-9.812a27.409,27.409,0,0,1-.5-5.323",
    transform: "translate(1642.142 671.514)",
    fill: "#b1d34a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7027",
    "data-name": "Path 7027",
    d: "M4.367,16.276,0,19.621l.875,5.594,6.7,8.543L12.7,28.371s10.679.552,12.447,1.722c1.791,1.171,3.487,4.862,3.487,4.862l4.425,2.05,2.49-1.658,1.487-3.258s-4.931-4.9-6.381-5.475C27.346,25.033,4.96,16.458,4.367,16.276",
    transform: "translate(1684.705 735.947)",
    fill: "#ffb080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7029",
    "data-name": "Path 7029",
    d: "M147.926,430.544l-5.207,10.807a28.386,28.386,0,0,0-.536,7.7,27.413,27.413,0,0,0,1.4,3.357,41.986,41.986,0,0,0,36.185-.572c.665-9.432-.493-14.234-.493-14.234Z",
    transform: "translate(1561.789 377.65)",
    fill: "#221e3f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7030",
    "data-name": "Path 7030",
    d: "M200.107,105.8s14.393,1.772,14.082,2.37c-.3,2.118,1.779,4.452,1.779,4.452s-8.758,1.83-12.52.231c-6.119-2.622-5.354-4.9-5.354-4.9a3.266,3.266,0,0,0,2.013-2.154",
    transform: "translate(1513.516 668.437)",
    fill: "#d7ad9b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7026",
    "data-name": "Path 7026",
    d: "M167.549,2.358a42.056,42.056,0,0,0-30.06.878c-.116,2.793-2.2,12.67-2.794,14.834-4.66,16.9,5.774,25,12.7,27.26,10.111,3.293,18.409-9.768,19.214-14.174.866-4.736-5.255-14.744-2.878-18.807a42.216,42.216,0,0,0,3.815-9.991",
    transform: "translate(1569.211 750.023)",
    fill: "#221e3f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7032",
    "data-name": "Path 7032",
    d: "M263.032,354.8l19.626-9.975.656-4.082-5.839-9.841-7.036,6.067,2.237,2.873-3.123,1.408-14.68,11.67-1.162-.87-5.356-.868-4.027,4.179,2.7,2.96,7.561.428Z",
    transform: "translate(1473.387 463.826)",
    fill: "#ffb080"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7028",
    "data-name": "Path 7028",
    d: "M7.58,55.171l-6.7-8.543L0,41.034,1.848,45.82l4.8,3.238,6.054.726Z",
    transform: "translate(1684.705 714.534)",
    fill: "#ef9470"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2882",
    "data-name": "Group 2882",
    transform: "translate(1704.223 784.268)",
    opacity: 0.51,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    "data-name": "Group 1168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1167",
    "data-name": "Group 1167",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163",
    opacity: 0.59
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5588",
    "data-name": "Path 5588",
    d: "M144.735,187.1c-2.989,8.455.23,21.161,7.19,28.379s15.026,6.215,18.016-2.24-.23-21.161-7.19-28.379-15.026-6.215-18.016,2.24",
    transform: "translate(-143.619 -180.039)",
    fill: "#ff3131",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1166",
    "data-name": "Group 1166",
    transform: "translate(3.777 6.113)",
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    "data-name": "Group 1164",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5589",
    "data-name": "Path 5589",
    d: "M172.341,230.136c-2.055,5.812.158,14.545,4.942,19.506s10.328,4.272,12.383-1.54-.158-14.545-4.942-19.506-10.328-4.272-12.383,1.54",
    transform: "translate(-171.574 -225.283)",
    fill: "#ff3131",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5590",
    "data-name": "Path 5590",
    d: "M189.988,258.127c-1.444,4.083.111,10.22,3.472,13.706s7.257,3,8.7-1.082-.111-10.22-3.472-13.706-7.257-3-8.7,1.082",
    transform: "translate(-183.257 -244.627)",
    fill: "#ff3131",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2883",
    "data-name": "Group 2883",
    transform: "translate(1702.945 781.738)",
    opacity: 0.39,
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1170",
    "data-name": "Group 1170",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5591",
    "data-name": "Path 5591",
    d: "M154.43,207.14a10.745,10.745,0,0,1-2.262-.248l.141-.654a9.928,9.928,0,0,0,2.556.222l.032.668c-.154.007-.311.011-.467.011m2.284-.276-.162-.649a8.463,8.463,0,0,0,2.351-.984l.348.571a9.124,9.124,0,0,1-2.537,1.061m-6.291-.487a15.287,15.287,0,0,1-2.445-1.182l.342-.575a14.612,14.612,0,0,0,2.338,1.13Zm10.3-1.671-.448-.5a10.93,10.93,0,0,0,1.688-1.944l.552.378a11.6,11.6,0,0,1-1.792,2.063m-14.246-.51a22.034,22.034,0,0,1-2.069-1.734l.459-.486a21.388,21.388,0,0,0,2.006,1.681Zm-3.331-3.013c-.594-.645-1.175-1.34-1.726-2.064l.533-.405c.538.708,1.106,1.386,1.686,2.016Zm20.293-.1-.6-.3a16.5,16.5,0,0,0,.857-2q.071-.2.137-.4l.636.208q-.069.211-.143.419a17.1,17.1,0,0,1-.892,2.086m-23.063-3.421c-.492-.73-.967-1.5-1.412-2.288l.583-.329c.436.773.9,1.528,1.384,2.243Zm24.582-.819-.651-.152a23.189,23.189,0,0,0,.447-2.582l.665.078a23.778,23.778,0,0,1-.46,2.657m-26.834-3.051c-.4-.792-.771-1.614-1.113-2.443l.618-.256c.337.815.7,1.622,1.093,2.4Zm27.442-1.395-.668-.034c.023-.469.035-.952.035-1.433,0-.392-.008-.795-.023-1.2l.669-.026c.016.41.024.821.024,1.222,0,.493-.012.986-.036,1.467m-29.2-2.718c-.3-.838-.578-1.7-.821-2.555l.644-.182c.239.842.51,1.687.806,2.511Zm28.427-1.7c-.081-.86-.2-1.738-.346-2.61l.659-.113c.152.888.271,1.783.353,2.66Zm-29.7-2.589c-.2-.875-.378-1.761-.516-2.633l.661-.1c.136.856.306,1.726.507,2.585Zm29.011-1.745c-.188-.85-.409-1.709-.659-2.553l.642-.189c.254.858.479,1.732.67,2.6Zm-29.764-2.663c-.1-.9-.157-1.8-.179-2.681l.669-.017c.022.86.081,1.743.175,2.627Zm28.568-1.564c-.288-.83-.607-1.658-.95-2.46l.615-.263c.348.816.674,1.659.966,2.5Zm-28.071-2.887-.669-.023c.031-.915.106-1.818.222-2.683l.663.089c-.113.843-.186,1.724-.217,2.617m26.393-1.173c-.386-.8-.8-1.579-1.237-2.328l.579-.336c.443.763.867,1.562,1.26,2.373Zm-25.88-3.166-.654-.139a20.746,20.746,0,0,1,.727-2.6l.006-.018.63.224-.006.016a20.089,20.089,0,0,0-.7,2.519m23.721-.657c-.486-.744-1-1.464-1.532-2.139l.527-.413c.542.691,1.068,1.426,1.565,2.186Zm-22.349-3.484-.6-.288a14.175,14.175,0,0,1,1.392-2.337l.537.4a13.5,13.5,0,0,0-1.326,2.226m19.694,0c-.233-.262-.472-.52-.711-.768-.371-.384-.751-.754-1.131-1.1l.45-.495c.391.356.782.736,1.162,1.131.245.254.49.519.729.787Zm-3.179-2.991a17.829,17.829,0,0,0-2.173-1.442l.326-.584a18.5,18.5,0,0,1,2.255,1.5Zm-14.063-.532-.468-.478a9.879,9.879,0,0,1,2.2-1.637l.319.589a9.2,9.2,0,0,0-2.052,1.526m10.331-1.667a11.933,11.933,0,0,0-2.477-.73l.116-.659a12.6,12.6,0,0,1,2.616.771Zm-6.708-.515-.194-.64a9.371,9.371,0,0,1,2.717-.4l.037,0-.035.318v.349h0a8.7,8.7,0,0,0-2.523.367",
    transform: "translate(-134.163 -161.312)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2884",
    "data-name": "Group 2884",
    transform: "translate(1705.091 786.314)",
    opacity: 0.37,
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    "data-name": "Group 1174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    "data-name": "Group 1173",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5592",
    "data-name": "Path 5592",
    d: "M157.447,227.314c-6.2-6.432-9.07-17.823-6.394-25.392,1.266-3.582,3.608-5.912,6.594-6.56,3.389-.736,7.24.821,10.563,4.267,6.2,6.432,9.071,17.823,6.4,25.392-1.266,3.582-3.608,5.911-6.594,6.559a8.822,8.822,0,0,1-4.84-.388,15.156,15.156,0,0,1-5.725-3.879m.636-29.943c-2.264.491-4.072,2.35-5.092,5.236-2.443,6.909.22,17.352,5.936,23.28,2.818,2.923,5.97,4.266,8.65,3.686,2.263-.491,4.071-2.351,5.091-5.236,2.443-6.909-.22-17.353-5.937-23.28a13.13,13.13,0,0,0-4.924-3.371,6.8,6.8,0,0,0-3.723-.315",
    transform: "translate(-150.05 -195.184)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2885",
    "data-name": "Group 2885",
    transform: "translate(1710.803 794.494)",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5593",
    "data-name": "Path 5593",
    d: "M192.866,259.144c-1.444,4.084.111,10.22,3.473,13.706s7.257,3,8.7-1.082-.111-10.22-3.472-13.706-7.257-3-8.7,1.082m1.572,1.684c1.052-2.976,3.891-3.329,6.34-.788s3.582,7.012,2.53,9.988-3.891,3.329-6.34.789-3.582-7.012-2.53-9.988",
    transform: "translate(-192.327 -255.734)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2886",
    "data-name": "Group 2886",
    transform: "translate(1715.379 801.297)",
    opacity: 0.39,
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5594",
    "data-name": "Path 5594",
    d: "M228.941,306.765a4.391,4.391,0,0,1,1.033,4.078c-.429,1.215-1.589,1.359-2.589.322a4.391,4.391,0,0,1-1.033-4.078c.43-1.215,1.589-1.359,2.589-.322",
    transform: "translate(-226.191 -306.072)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2887",
    "data-name": "Group 2887",
    transform: "translate(1704.007 808.377)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5595",
    "data-name": "Path 5595",
    d: "M149.981,362.7l-1.365-1.4L145,364.871l-2.968-2.347,5.96-3.039,1.278,1.145,2.961-2.151Z",
    transform: "translate(-142.027 -358.479)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2888",
    "data-name": "Group 2888",
    transform: "translate(1703.266 787.629)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5596",
    "data-name": "Path 5596",
    d: "M144.483,215.806l-4.427-4.523.534-2.04-4.053-4.331,4.672,2.773-.1,3.391Z",
    transform: "translate(-136.536 -204.912)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2889",
    "data-name": "Group 2889",
    transform: "translate(1726.073 793.076)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5597",
    "data-name": "Path 5597",
    d: "M309.537,245.229l-2.79,1.287.754,1.665-2.156,1.668,3.345-.37-1.14-2.432Z",
    transform: "translate(-305.345 -245.229)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2890",
    "data-name": "Group 2890",
    transform: "translate(1696.008 800.17)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    "data-name": "Group 1192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5598",
    "data-name": "Path 5598",
    d: "M94.577,299.662l-5.6,2.081-.921-2.111-5.178.081-.054-1.976,7.2.028-.506,2.571Z",
    transform: "translate(-82.82 -297.737)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2891",
    "data-name": "Group 2891",
    transform: "translate(1724.484 813.989)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5599",
    "data-name": "Path 5599",
    d: "M293.589,400.015l2.5,6.1,2.084-1.4L301.227,410l.871-3.332-4.273-5.109-1.406,2.491Z",
    transform: "translate(-293.589 -400.015)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2892",
    "data-name": "Group 2892",
    transform: "translate(1729.692 807.037)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    "data-name": "Group 1198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5600",
    "data-name": "Path 5600",
    d: "M332.136,352.18l4.466.563-.04,3.111,5.568-1.078-3.87-1.028-.586-5.185Z",
    transform: "translate(-332.136 -348.562)",
    fill: "#ff3131"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4411",
    "data-name": "Rectangle 4411",
    width: 71.997,
    height: 83.854,
    transform: "translate(1684.818 759.943)",
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4412",
    "data-name": "Rectangle 4412",
    width: 71.997,
    height: 83.854,
    transform: "translate(1678.157 750.025)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainPointMidBackGreen);
export default __webpack_public_path__ + "static/media/painPointMidBackGreen.b6383e274ea808d9d5646fcb70fed196.svg";
export { ForwardRef as ReactComponent };